/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts
 */

import { FieldType } from "../../type-system/FieldType";
import { shopifyPaymentsTransactionTypeEnumOptions } from "./constants";
import {
  ShopifyBalanceTransactionKey,
  ShopifyBalanceTransactionToOrderKey,
  ShopifyBalanceTransactionToOrderTransactionKey,
  ShopifyBalanceTransactionToPayoutKey,
  ShopifyBalanceTransactionToShopKey,
  ShopifyOrderKey,
  ShopifyOrderTransactionKey,
  ShopifyPayoutKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyBalanceTransactionKey,
  "2022-01": {
    name: "Shopify Balance Transaction",
    fields: [
      {
        name: "Amount",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "amount" },
        },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "currency" },
        },
      },
      {
        name: "Fee",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "fee" },
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "id" },
        },
      },
      {
        name: "Net",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "net" },
        },
      },
      {
        name: "Payout",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToPayoutKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "payout_id" },
        },
        configuration: {
          relatedModelKey: ShopifyPayoutKey,
        },
      },
      {
        name: "Payout Status",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "payout_status" },
        },
      },
      {
        name: "Processed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "processed_at" },
        },
      },
      {
        name: "Source ID",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "source_id" },
        },
      },
      {
        name: "Source Type",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "source_type" },
        },
      },
      {
        name: "Source Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToOrderKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source_order_id",
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Source Order Transaction",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToOrderTransactionKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source_order_transaction_id",
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderTransactionKey,
        },
      },
      {
        name: "Test",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "test" },
        },
      },
      {
        name: "Type",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "type" },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToShopKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" },
        },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "balance", syncFunction: "transactions" },
  },
  "2024-01": {
    fields: [
      {
        name: "Adjustment Order Transactions",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "adjustment_order_transactions" },
        },
      },
    ],
  },
  "2024-07": {
    fields: [
      {
        name: "Adjustment Reason",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "adjustment_reason" },
        },
      },
    ],
  },
  "2025-04": {
    graphQLTypename: "ShopifyPaymentsBalanceTransaction",
    fields: [
      {
        name: "Amount",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "amount",
            graphQLFieldKey: "amount",
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "currency" },
        },
        isDeleted: true,
      },
      {
        name: "Fee",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "fee",
            graphQLFieldKey: "fee",
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" },
        },
      },
      {
        name: "Net",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "net",
            graphQLFieldKey: "net",
            graphQLSelection: `
            amount
            currencyCode
            `,
          },
        },
      },
      {
        name: "Payout",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToPayoutKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "payout_id",
            graphQLFieldKey: "associatedPayout",
            graphQLSelection: `
            id
            status
            `,
          },
        },
        configuration: {
          relatedModelKey: ShopifyPayoutKey,
        },
      },
      {
        name: "Payout Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "payout_status", graphQLFieldKey: "associatedPayoutStatus", skipGraphQLSelection: true },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "ACTION_REQUIRED" },
            { name: "CANCELED" },
            { name: "FAILED" },
            { name: "PAID" },
            { name: "PENDING" },
            { name: "SCHEDULED" },
            { name: "IN_TRANSIT" },
          ],
        },
      },
      {
        name: "Processed At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "processed_at" },
        },
        isDeleted: true,
      },
      {
        name: "Source ID",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "source_id", graphQLFieldKey: "sourceId" },
        },
      },
      {
        name: "Source Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "source_type", graphQLFieldKey: "sourceType", isShopifyEnum: true },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "ADJUSTMENT" },
            { name: "ADJUSTMENT_REVERSAL" },
            { name: "CHARGE" },
            { name: "DISPUTE" },
            { name: "REFUND" },
            { name: "SYSTEM_ADJUSTMENT" },
            { name: "TRANSFER" },
          ],
        },
      },
      {
        name: "Source Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToOrderKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source_order_id",
            graphQLFieldKey: "associatedOrder",
            graphQLSelection: "id",
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Source Order Transaction",
        fieldType: FieldType.BelongsTo,
        key: ShopifyBalanceTransactionToOrderTransactionKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "source_order_transaction_id",
            graphQLFieldKey: "sourceOrderTransactionId",
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderTransactionKey,
        },
      },
      {
        name: "Test",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "test", graphQLFieldKey: "test" },
        },
      },
      {
        name: "Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "type", graphQLFieldKey: "type", isShopifyEnum: true },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: shopifyPaymentsTransactionTypeEnumOptions,
        },
      },
      {
        name: "Transaction Date",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "transactionDate" },
        },
      },
      {
        name: "Adjustment Orders",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "adjustmentsOrders",
            graphQLSelection: `
            amount {
              currencyCode
              amount
            }
            link
            name
            orderTransactionId
            `,
          },
        },
      },
    ],
    addedRequiredScopes: ["read_shopify_payments_accounts"],
    syncConfig: {
      type: "graphql_list",
      resource: "balanceTransactions",
      filters: {},
    },
  },
  "2026-10": {
    fields: [
      {
        name: "Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "type",
            graphQLFieldKey: "type",
            isShopifyEnum: true,
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [...shopifyPaymentsTransactionTypeEnumOptions, { name: "CURRENCY_CONVERSION" }],
        },
      },
    ],
  },
};

export const ShopifyBalanceTransaction = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
